<template>
  <nav class="results-pagination" aria-label="Pagination">
    <button
      type="button"
      class="page-btn"
      :disabled="currentPage <= 1"
      aria-label="Page précédente"
      @click="changePage(currentPage - 1)"
    >
      &lt;
    </button>
    <template v-for="(item, index) in pageItems">
      <span v-if="item === '…'" :key="`gap-${index}`" class="page-gap">…</span>
      <button
        v-else
        :key="`page-${item}`"
        type="button"
        class="page-btn"
        :class="{ 'is-active': item === currentPage }"
        :disabled="item === currentPage"
        :aria-current="item === currentPage ? 'page' : null"
        @click="changePage(item)"
      >
        {{ item }}
      </button>
    </template>
    <button
      type="button"
      class="page-btn"
      :disabled="currentPage >= nbPages"
      aria-label="Page suivante"
      @click="changePage(currentPage + 1)"
    >
      &gt;
    </button>
  </nav>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "Pagination",

  props: {
    nbPages: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    ...mapState("projects", ["currentPage"]),

    pageItems() {
      const total = Math.max(this.nbPages, 1);
      const current = this.currentPage;
      if (total <= 5) {
        return Array.from({ length: total }, (_, index) => index + 1);
      }
      if (current <= 3) {
        return [1, 2, 3, "…", total - 1, total];
      }
      if (current >= total - 2) {
        return [1, 2, "…", total - 2, total - 1, total];
      }
      return [
        1,
        2,
        "…",
        current - 1,
        current,
        current + 1,
        "…",
        total - 1,
        total,
      ];
    },
  },

  methods: {
    ...mapMutations("projects", ["SET_CURRENT_PAGE"]),

    changePage(pageNumber) {
      if (
        pageNumber < 1 ||
        pageNumber > this.nbPages ||
        pageNumber === this.currentPage
      )
        return;
      this.SET_CURRENT_PAGE(pageNumber);
      this.$emit("page-update", pageNumber);
    },
  },
};
</script>

<style scoped>
.results-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
}

.page-btn,
.page-gap {
  min-width: 1.35rem;
  height: 2rem;
  padding: 0 0.2rem;
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 2rem;
  text-align: center;
}

.page-btn {
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  line-height: 2rem;
}

.page-btn:disabled {
  cursor: default;
}

.page-btn:disabled:not(.is-active) {
  opacity: 0.35;
}

.page-btn.is-active {
  color: #3a468e;
}

.page-gap {
  letter-spacing: 0.04em;
}
</style>
